// import { inject } from 'aurelia-framework';
import { Container } from "aurelia-dependency-injection";
import $ from "jquery";
import "jquery-ui-dist";
import { TranscriptGenerator } from "../../services/transcriptGenerator";
import { YoutubeAPI } from "../../services/youtubeAPI";

// @inject(BrandVideoAPI)
export class VideoDetailsBase {
  constructor(
    authService,
    userMessageService,
    router,
    bgMusicApi,
    fontApi,
    accountApi,
    apiBase,
    TestimonialRequestAPI,
    TestimonialLinkSubmissionAPI,
    BrandVideoAPI,
    envService,
    isAdmin = false,
    transcriptGenerator = null,
    chatbotApi
  ) {
    this.isAdmin = isAdmin;
    this.authService = authService;
    this.userMessageService = userMessageService;
    this.router = router;
    this.envService = envService;

    this.apiBase = apiBase;
    this.TestimonialRequestAPI = TestimonialRequestAPI;
    this.TestimonialLinkSubmissionAPI = TestimonialLinkSubmissionAPI;
    this.BrandVideoAPI = BrandVideoAPI;
    this.transcriptGenerator = transcriptGenerator;

    this.bgMusicApi = bgMusicApi;
    this.fontApi = fontApi;
    this.accountApi = accountApi;
    this.youtubeApi = new YoutubeAPI(
      this.yotubeAPILoaded.bind(this),
      this.youtubeApiReady.bind(this),
      this.apiBase
    );
    this.chatbotApi = chatbotApi;
    console.log("✅ ChatBotAPI injected: ", this.chatbotApi);  // Check if injected properly
    // this.facebookApi = facebookApi;
    // this.facebookApi.setCallbacks(this.facebookApiLoaded.bind(this), this.facebookApiReady.bind(this));
    console.log("----------------");
    console.log(this.youtubeApi);
    console.log(this.apiBase);

    this.background_music = null;

    this.youtubeReady = false;
    // this.facebookReady = false;

    this.saving = false;
    this.sending = false;
    window.googleApiClientReady = this.youtubeApi.googleApiClientReady.bind(
      this.youtubeApi
    );
    // window.fbAsyncInit = this.facebookApi.facebookApiClientReady.bind(this.facebookApi);

    this.instructionsMax = 250;
    this.callToActionMax = 16;

    this.socialMediaUploading = false;
    this.remove_cta = false;

    this.insertChatbotVideo = false;
    this.isUsedInChatbot=false;
    this.isChatbotEnabled = false;

    this.editable = true;

    this.loading = true;

    this.app_name = "Magnfi";
    this.test_app =
      "http://magnfidockerdev-env.eba-gn5msvrr.us-east-2.elasticbeanstalk.com/";

    // this.brandVideoAPI = brandVideoAPI;

    if (window.whitelabel) {
      this.app_name = window.app_name;
    }

    this.authServicee = authService;
    this.userMessageService = userMessageService;
    this.accountApii = accountApi;
    this.brand_video_status_message = "";
    this.brand_video_progress = false;
    this.brand_video_src_changed = false;

    this.isWLAdmin = false;
    if (this.authService.getUser().role === "WLADMIN") {
      this.isWLAdmin = true;
    }

    this.isAdmin = false;
    if (this.authService.getUser().role === "ADMIN") {
      this.isAdmin = true;
    }

    this.isYTManager = false;
    if (this.authService.getUser().role === "YTMANAGER") {
      this.isYTManager = true;
    }
    this.run_once = true;
    this.run_once_accept = true;
    this.customCTAImageEnable = false;

    this.videoVisibitily = "Public";
    this.uploadDefault = false;

    // subtitles
    this.subtitles = {
      caption: [],
      styles: {},
    };
    this.loadingTranscript = false;
    this.enableSubtitle = true;
    this.subtitleStyleIndex = 0;
  }

  visibilityChange(value) {
    this.videoVisibitily = value;
  }
  activate(params, route) {
    this.backgroundMusicList = null;
    this.bgWebPath = null;
    this.bgContentType = null;

    this.status = null;

    //this.reset();

    this.id = params.id;
    this.link_submission = route.settings.link_submission || false;
    this.testimonial_request = route.settings.testimonial_request || false;
    this.brand_video = route.settings.brand_video || false;

    if (this.link_submission) {
      this.video_src =
        this.apiBase + "/testimonialLinkSubmission/getProducedVideo/";
      this.submitted_src =
        this.apiBase + "/testimonialLinkSubmission/getSubmittedVideo/";
      this.cta_src = this.apiBase + "/testimonialLinkSubmission/getCustomCTA/";
      this.api = Container.instance.get(this.TestimonialLinkSubmissionAPI);
      this.transcript_src = this.apiBase + "/testimonialLinkSubmission/getTranscriptFile/"; // transcript file

    } else {
      if (this.brand_video) {
        this.video_src = this.apiBase + "/brandVideo/getProducedVideo/";
        this.submitted_src = this.apiBase + "/brandVideo/getSubmittedVideo/";
        this.cta_src = this.apiBase + "/brandVideo/getCustomCTA/";
        this.transcript_src = this.apiBase + "/brandVideo/getTranscriptFile/";
        this.api = Container.instance.get(this.BrandVideoAPI);
      } else {
        this.video_src = this.apiBase + "/testimonialRequest/getProducedVideo/";
        this.submitted_src =
          this.apiBase + "/testimonialRequest/getSubmittedVideo/";
        this.cta_src = this.apiBase + "/testimonialRequest/getCustomCTA/";
        this.api = Container.instance.get(this.TestimonialRequestAPI);
      }
    }

    console.log("Testimonial Request APi", this.api);
    if (
      this.authService.getAccount() != null &&
      this.authService.getAccount().owner_user_id != null &&
      this.authService.getAccount().logo_file != null
    ) {
      this.account_owner_user_id = this.authService.getAccount().owner_user_id;
    } else {
      this.userMessageService.setUserMessage("user", "Please set up account.");
      if (this.authService.getAccount().logo_file == null)
        this.userMessageService.setUserMessage("user", "Logo is required.");
      this.router.navigate("account");
    }

    this.instructionsCharsLeft = this.instructionsMax;
    this.callToActionCharsLeft = this.callToActionMax;

    this.showVideo = false;

    this.socialMediaUploading = false;

    this.call_to_action_select = -1;
    this.instructions_select = -1;

    //if(this.facebookApi.loaded)
    //    this.facebookApiLoaded();

    this.testimonial_expire_days = window.testimonial_expire_days;

    this.hasCustomOpener = false;

    this.account_org_phone = this.authService.getAccount().org_phone;
    this.account_org_email = this.authService.getAccount().org_email;
    this.account_website = this.authService.getAccount().website;

    this.isMobile = this.envService.isMobile();
    if (0 && this.brand_video && !this.id) {
      console.log("PBV:: new brand video ");
      //this.editable = false;
      this.include_call_to_action = true;
      this.useCustomOpener = false;
    }
    if (this.brand_video) {
      /*set the rout so left listing can come from branded video instead of testimonialAPI
            TestimonialRequestAPI, getList*/
      localStorage.setItem("rout", "#/user/video/brand");
      this.brand_video_water_mark = true;
    }
    this.load();
    this.loadBgMusic();
    this.transcriptGenerator = new TranscriptGenerator();
    this.subtitles = {
      caption: [],
      styles: {},
    };

    this.subtitleStyleIndex=null;
    this.loadingTranscript=false;
    //this.progressbar = $( "#progressbar" );
    //this.progressLabel = $( ".progress-label" );




      // this.chatbotApi.getChatbotDetail(
      //   this.authService.getUser().token,
      //   (data)=>{
      //       this.isChatbotEnabled = data.website?true:false;
      //   },
      //   ()=>{});


  }

  attached() {
    // this.fetchChatbotDetails();
    // this.isYTManager = false;
    // if (this.authService.getUser().role === "YTMANAGER") {
    //   this.isYTManager = true;
    // }
console.log('sssssfff',this.authService.getUser())
    if(this.authService.getUser()){
          this.isWLAdmin = false;
          if (this.authService.getUser().role === "WLADMIN") {
            this.isWLAdmin = true;
          }

          this.isAdmin = false;
          if (this.authService.getUser().role === "ADMIN") {
            this.isAdmin = true;
          }

          this.isYTManager = false;
          if (this.authService.getUser().role === "YTMANAGER") {
            this.isYTManager = true;
          }
  }
  
    //$( "#selector" ).progressbar();
    /*$( "#selector" ).progressbar({
      value: 37
    });*/
    this.videoPreviewPlayer.addEventListener(
      "blur",
      function (e) {
        //this.showVideoClosed()
      }.bind(this)
    );


    this.loadBgMusic();

    this.transcriptGenerator = new TranscriptGenerator();
    this.subtitles = {
      caption: [],
      styles: {},
    };

    this.subtitleStyleIndex=null;
    this.loadingTranscript=false;

    if (this.bgPreviewPlayer) {
      this.bgPreviewPlayer.pause();
    }

    // if(this.isAdmin == false){
    //     this.requestListt.activate();
    //     this.submissionListt.activate();
    // }

    this.rout = window.location.href;
    console.log("Case study URL:", this.rout);
    if (
      !this.rout.includes("#/wladmin/video/request") &&
      !this.rout.includes("#/admin/video/request") &&
      !this.rout.includes("#/ytmanager/video/request") &&
      !this.rout.includes("#/wladmin/video/brand") &&
      !this.rout.includes("#/admin/video/brand") &&
      !this.rout.includes("#/ytmanager/video/brand") &&
      !this.rout.includes("#/wladmin/video/link") &&
      !this.rout.includes("#/admin/video/link")
    ) {
      this.requestListt.activate();
      this.submissionListt.activate();
    }

    //if(this.status > 0  && this.elastic_transcoder >= 0){
    //only run if status is greater then zero and elastic transcoder is not false
    //for new brand video status is always 0 and elastic transcoder is alwas false
    $("#progressbar").progressbar({
      value: false,
      change: function () {
        $(".progress-label").text($("#progressbar").progressbar("value") + "%");
      },
      complete: function () {
        $(".progress-label").text("Loading!");
      },
    });
    //}
  }

  progress() {
    if (!$("#progressbar")) return false;

    var val = $("#progressbar").progressbar("value") || 0;
    $("#progressbar").progressbar("value", val + 1);

    if (val < 99) {
      console.log("Recursive calling of progress");
      setTimeout(this.progress.bind(this), 12000);
    }
  }

  detached() {
    if (this.bgPreviewPlayer) {
      this.bgPreviewPlayer.pause();
    }

    if (this.videoPreviewPlayer) {
      this.videoPreviewPlayer.pause();
    }
  }

  loadBgMusic() {
    this.bgMusicApi.getBackgroundMusicList(
      this.authService.getUser().token,
      this.loadBgMusicSuccess.bind(this),
      this.saveLoadError.bind(this)
    );
  }

  loadBgMusicSuccess(data) {
    this.backgroundMusicList = data;

    this.loadFonts();
  }

  loadFonts() {
    this.fontApi.getFontList(
      this.authService.getUser().token,
      this.loadFontSuccess.bind(this),
      this.saveLoadError.bind(this)
    );
  }

  loadFontSuccess(data) {
    this.fontList = data;
    this.call_to_action_font = this.fontList[0];

    if (this.id) {
      this.load();
    } else {
      this.reset();
    }
  }

  bgMusicChanged() {
    if (this.background_music && this.background_music != -1) {
      if (this.background_music.id == 0) this.bgPreviewPlayer.src = null;
      else
        this.bgPreviewPlayer.src =
          "api/backgroundMusic/getMusicFile/" +
          this.background_music.id +
          "?Authorization=" +
          this.authService.getUser().token;
    } else {
      if (this.backgroundMusicList != "" && this.backgroundMusicList != null) {
        var rand = Math.floor(
          Math.random() * this.backgroundMusicList.length - 1
        );

        this.background_music = this.backgroundMusicList[rand];
        this.bgPreviewPlayer.src =
          "api/backgroundMusic/getMusicFile/" +
          this.background_music.id +
          "?Authorization=" +
          this.authService.getUser().token;
      }
    }
    this.bgPreviewPlayer.pause();
    this.bgPreviewPlayer.load();

    this.bgPreviewPlayer.volume = 0.8;
  }

  reset() {
    this.status = 0;
    this.status_text = "New";
    this.customer_first_name = null;
    this.customer_last_name = null;
    this.customer_email = null;

    this.video_name = null;
    this.update_video_name = null;

    this.call_to_action = null;

    this.instructions = null;
    this.include_email = false;
    this.include_phone = false;
    this.include_call_to_action = false;
    if (this.brand_video) {
      this.include_call_to_action = false;
    }
    this.cta_override_website = this.account_website;

    if (this.backgroundMusicList) this.bgMusicChanged();

    this.public = false;
    this.featured = false;
    this.customCTALink = null;
    this.remove_cta = false;

    this.editable = true;
    this.elastic_transcoder = false;
    this.brand_video_url = null;
    if ((this.isAdmin || this.isYTManager) && !location.href.includes('/user') ) {
      this.accountApi.hasCustomOpener(
        this.account_owner_user_id,
        { type: this.brand_video ? "any" : "horizontal" },
        this.authService.getUser().token,
        (result) => {
          this.hasCustomOpener = result;
        },
        this.saveLoadError.bind(this)
      );
    } else {
      this.accountApi.hasCustomOpener(
        { type: this.brand_video ? "any" : "horizontal" },
        this.authService.getUser().token,
        (result) => {
          this.hasCustomOpener = result;
        },
        this.saveLoadError.bind(this)
      );
    }
  }

  load(processingWait = false) {
    //if(this.status > 0  && this.elastic_transcoder >= 0){
    //only run if status is greater then zero and elastic transcoder is not false
    //for new brand video status is always 0 and elastic transcoder is alwas false
    setTimeout(this.progress.bind(this), 12000);

    //}
    console.log("rec id: " + this.id);
    if (this.id == "" || this.id === undefined) return;
    console.log("PW", processingWait, this.brand_video, this.id);
    if (processingWait && this.brand_video) {
      this.api.getById(
        this.id,
        this.authService.getUser().token,
        (data) => {
            this.setData(data);
          console.log(
            "PW:  s " + data.status + " - " + data.elastic_transcoder
          );
          this.editable = false;
          if (data.status == 3 && (data.elastic_transcoder == 20 || data.elastic_transcoder == 2 || data.elastic_transcoder == 201)) {
            //video ready for preview
            console.log("Video ready setting the progress bar balue to 100%");
            this.brand_video_water_mark = false;
            $("#progressbar").progressbar("value", 100); //val = 99;
            this.editable = true;
          }

          if (data.status == 0 || data.status == 1 || data.status == 2) {
            console.log("PW::: calling load again " + data.status);

            setTimeout(this.load.bind(this), 7000, true);
          }
        },
        this.saveLoadError.bind(this)
      );
    } else   if (processingWait && this.link_submission) {
      this.api.getById(
        this.id,
        this.authService.getUser().token,
        (data) => {
            this.setData(data);
          this.editable = false;
    
          // creating mode for link_submission
          if (data.status == 4 || data.status == 5) {
            console.log("PW::: calling load again " + data.status);
            this.editable = true;
            setTimeout(this.load.bind(this), 7000, true);
          }
        },
        this.saveLoadError.bind(this)
      );
    }  
    else  {
      this.api.getById(
        this.id,
        this.authService.getUser().token,
        this.saveLoadSuccess.bind(this),
        this.saveLoadError.bind(this)
      );
    }
  }

  save() {
    if (this.validate()) {
      this.saving = true;
      this.api.save(
        this.getData(),
        this.cta_files && this.cta_files.length > 0 && this.showCTAUpload
          ? this.cta_files[0]
          : null,
        this.authService.getUser().token,
        this.saveLoadSuccess.bind(this),
        this.saveLoadError.bind(this)
      );
    }
  }

  saveLoadSuccess(data) {
    console.log("Brand Video ===> " + JSON.stringify(data));

    this.setData(data);

    if (this.customCTAImageEnable) {
      this.api.sendRequest(
        this.getData(),
        this.authService.getUser().token,
        // this.saveLoadSuccess.bind(this),
        null,
        null,
        this.saveLoadError.bind(this)
      );

      this.customCTAImageEnable = false;
    }
    console.log('ssssssssssssssssssss',this.isAdmin , this.isYTManager,location.href.includes('/user'))
    if ((this.isAdmin || this.isWLAdmin || this.isYTManager) && !location.href.includes('/user') ) {
      this.accountApi.hasCustomOpener(
        this.account_owner_user_id,
        { type: this.brand_video ? "any" : "horizontal" },
        this.authService.getUser().token,
        (result) => {
          this.hasCustomOpener = result;
        },
        this.saveLoadError.bind(this)
      );
    } else {
      this.accountApi.hasCustomOpener(
        { type: this.brand_video ? "any" : "horizontal" },
        this.authService.getUser().token,
        (result) => {
          this.hasCustomOpener = result;
        },
        this.saveLoadError.bind(this)
      );
    }

    if (this.saving && data.status != 201)
      this.userMessageService.setUserMessage("user", "Saved!");

    if (this.saving && data.status == 4){
      this.userMessageService.setUserMessage("user", "Creating video!");
      // this.load.bind(this)  
      setTimeout(this.load.bind(this), 7000, true);

    }

    if (this.sending && data.status != 201)
      this.userMessageService.setUserMessage("user", "Sent!");
    if (data.status == 201)
      this.userMessageService.setUserError("user", "Deleted!");

    this.sending = false;
    this.saving = false;
    this.showCTAUpload = false;
    console.log("window.site_url...", window.site_url, "...", data);
    if (data.status == 200 || data.status == 201) {
      const vidoePageSite = window.location.href;
      if (vidoePageSite.includes("user")) {
        console.log("window.site_url...user");
        this.router.navigate(window.site_url + "#/user" + "/video/request");
      } else if (vidoePageSite.includes("wladmin")) {
        console.log("window.site_url...wladmin");
        this.router.navigate(window.site_url + "#/user" + "/videos");
      } else if (vidoePageSite.includes("admin")) {
        console.log("window.site_url...admin");
        this.router.navigate(window.site_url + "#/user" + "/videos");
      }
    }

    if (
      this.brand_video &&
      (data.status == 0 ||
        data.status == 1 ||
        data.status == 2 ||
        this.status == 20)
    ) {
      //refreshing the brand video preview window
      console.log("PBV:: reloading the brand video preview window");
      setTimeout(this.load.bind(this), 7000, true);
    }
    if (this.brand_video && data.status == 4) {
      //refreshing the brand video preview window
      console.log("PBV:: reloading the brand video after acceptance");
       setTimeout(this.accept.bind(this), 7000, true);
    }
    if (this.brand_video && data.status >= 3) {
      console.log("PBV:: watermarking flag turned to false");
      this.brand_video_water_mark = false;
    }
    // window.open(window.site_url+'/#/user'+'/videos');
  }

  saveLoadSuccessDelete(data) {
    this.sending = false;
    this.saving = false;
    this.showCTAUpload = false;
    console.log("window.site_url...", window.site_url, "...", data);
    if (data.status == 200 || data.status == 201) {
      const vidoePageSite = window.location.href; //user/video/brand

      if (
        vidoePageSite.includes("user/video/request") ||
        vidoePageSite.includes("user/video/submission")
      ) {
        console.log("window.site_url...user");
        this.router.navigate(window.site_url + "#/user/video/request");
      } else if (vidoePageSite.includes("user/video/brand")) {
        console.log("window.site_url...user");
        this.router.navigate("#/user/video/brand");
      } else if (vidoePageSite.includes("wladmin")) {
        console.log("window.site_url...wladmin");
        this.router.navigate(window.site_url + "#/wladmin" + "/videos");
      } else if (vidoePageSite.includes("admin")) {
        console.log("window.site_url...admin");
        this.router.navigate(window.site_url + "#/admin" + "/videos");
      }

      this.userMessageService.setUserError("user", "Deleted!");
    }

    if (
      this.brand_video &&
      (data.status == 0 ||
        data.status == 1 ||
        data.status == 2 ||
        this.status == 20)
    ) {
      //refreshing the brand video preview window
      console.log("PBV:: reloading the brand video preview window");
      setTimeout(this.load.bind(this), 5000, true);
    }
  }

  saveLoadError(msg) {
    this.socialMediaUploading = false;
    this.userMessageService.setUserError("user", msg);
  }

  setData(data) {
    console.log("PBV::");
    console.log(data);
    this.id = data.id;
    this.account_owner_user_id = data.account_owner_user_id;
    this.status = data.status;
    this.status_text = data.status_text;
    this.customer_first_name = data.customer_first_name;
    this.customer_last_name = data.customer_last_name;
    this.customer_email = data.customer_email;
    this.customer_name =
      data.customer_first_name + " " + data.customer_last_name;
    this.sent_date = data.sent_date;
    this.capture_date = data.capture_date;
    this.expire_date = data.expire_date;
    this.formatted_status =
      '<span style="color: red;">' + this.status_text + "</span>";
  // if(this.video_name == undefined && this.video_topic == undefined){
    this.video_name = data.video_name;
    this.video_topic = data.video_topic;
    this.update_video_name = this.video_name;
    this.update_video_topic = this.video_topic;
    // alert
  // }
    this.elastic_transcoder = data.elastic_transcoder;
    this.brand_video_url = data.video_url;
    this.call_to_action = data.call_to_action;
    this.background_music = this.findBgMusic(data.background_music_id);
    this.instructions = data.instructions;
    this.include_email = data.include_email;
    this.include_email = data.include_email;
    this.storage_used = data.storage_used;
    this.isUsedInChatbot = data.is_used_in_chatbot;
    this.include_call_to_action = data.include_call_to_action;
    this.cta_override_website = data.cta_override_website;
    this.enableSubtitle = data.use_subtitles;
    this.transcriptGenerator.selectedIndex = data.subtitle_style_index;

    this.bgMusicChanged();
    this.callToActionKeyUp();

    var transcript_url =
      this.transcript_src +
      this.id +
      "?Authorization=" +
      this.authService.getUser().token;
    // if (this.subtitles.caption)
    if (this.transcript_src){
      this.transcriptGenerator.loadAWSJson(transcript_url, (json) => {

      if(json.hasOwnProperty('caption')){
        this.subtitles = json;
        this.transcriptGenerator.selectedStyle=json.styles
      }else{
        this.subtitles.caption = json;
        this.transcriptGenerator.onSelectedStyle(
          this.transcriptGenerator.selectedIndex
        );
      }

      });
    }

    if (
      this.status == (this.link_submission || this.brand_video ? 3 : 4) ||
      this.status == 100
    ) {
      this.videoPreviewPlayer.src =
        this.video_src +
        this.id +
        "?Authorization=" +
        this.authService.getUser().token +
        "&t=" +
        new Date();

      //console.log('PBV:: Branded Video, Elastic Transcoder ??? ' + this.brand_video + ' -- ' + this.elastic_transcoder)
      //console.log('PBV:: is video processed, source ', this.videoPreviewPlayer.src);
      if (0 && this.brand_video && this.elastic_transcoder > 0) {
        //console.log('PBV:: Getting video from s3');

        //getProducedVideo
        //this.videoPreviewPlayer.src = "https://staging-output-test.s3.amazonaws.com/brand_video/1073/processed.mp4";
        if (1) {
          //console.log('VIDEO_SRC:: WATERMARKED, ACCEPTED => OLD, NEW', this.videoPreviewPlayer1.src, this.brand_video_url );
          if (
            this.videoPreviewPlayer.src.indexOf(this.brand_video_url) !== -1
          ) {
            this.brand_video_src_changed = true;
            this.videoPreviewPlayer.src = this.brand_video_url;
            //console.log('VIDEO_SRC:: WATERMARKED, ACCEPTED => CHANGED');
          } else {
            //console.log('VIDEO_SRC:: WATERMARKED, ACCEPTED => NO CHANGE');
          }
        }

        //console.log('PBV:: preview source from s3', this.videoPreviewPlayer.src);
      }
      //this.videoPreviewPlayer.load();
      if (
        this.brand_video_src_changed &&
        this.brand_video &&
        this.elastic_transcoder > 0
      ) {
        //console.log('VIDEO_SRC:: WATERMARKED, ACCEPTED => SET TO FALSE AND NEW SOURCE LOADED...');
        //this.videoPreviewPlayer.load();
        this.brand_video_src_changed = false;
      } else {
        this.videoPreviewPlayer.load();
        this.videoPreviewPlayer1.src =
          this.video_src +
          this.id +
          "?Authorization=" +
          this.authService.getUser().token +
          "&t=" +
          new Date();
        this.videoPreviewPlayer1.load();
      }
    }

    this.public = data.public;
    this.featured = data.featured;

    this.customCTALink = data.custom_cta
      ? this.cta_src +
        this.id +
        "?Authorization=" +
        this.authService.getUser().token +
        "&t=" +
        new Date()
      : null;

    this.call_to_action_font = this.findFont(data.font_id);
    this.useCustomOpener = data.use_custom_opener;
    this.removeStartOpenerLogo = data.remove_start_opener_logo;

    this.processing_failed = data.processing_failed || false;

    if (this.isAdmin) {
      if (this.link_submission || this.brand_video) {
        this.editable = this.status == 3 || this.status == 100;
      } else {
        this.editable =
          this.status == 0 || this.status == 4 || this.status == 100;
      }

      this.editable =
        this.editable || (this.processing_failed && this.status < 200);
    } else {
      if (this.link_submission || this.brand_video) {
        this.editable =
          this.status == 3 || this.status == 1 || this.status == 100;
      } else {
        this.editable =
          this.status == 0 || this.status == 4 || this.status == 100;
      }
    }

    console.log("SetValue Status --> " + this.status);
    console.log("SetValue Editable --> " + this.editable);
    this.requestCount = this.authServicee.getAccount().request_count;

    if (this.brand_video && this.elastic_transcoder > 0) {
      //this code will create quick preview for brand video untill is is processed and doesn't touch the older branded videos
      //this.videoPreviewPlayer1.src = this.brand_video_url;
      var temp_file_name = localStorage.getItem("VideoEmailFileName");
      console.log("VIDEO_SRC:: temp file", temp_file_name);

      // var splitFile=temp_file_name.split("/");
      // var tarscriptFile=splitFile.slice(0,splitFile.length-1).join("/")+"/transcript.json"

      // $.getJSON(tarscriptFile,function(data){
      //   console.log(data)
      //   alert("ddd")
      // })

      console.log("VIDEO_SRC:: , status", this.brand_video, this.status);
      if (
        (this.status <= 2 || this.status == 20) &&
        temp_file_name &&
        temp_file_name.indexOf("brand_video") !== -1
      ) {
        this.video_src = localStorage.getItem("VideoEmailFileName");
        console.log("VIDEO_SRC:: Found branded video S3", this.video_src);
        if (1) {
          console.log(
            "VIDEO_SRC:: PREVIEW => OLD, NEW",
            this.videoPreviewPlayer1.src,
            this.video_src
          );
          if (
            this.videoPreviewPlayer1.src &&
            this.videoPreviewPlayer1.src.indexOf(this.video_src) !== -1
          ) {
            console.log("VIDEO_SRC:: PREVIEW => NO CHANGE");
          } else {
            this.brand_video_src_changed = true;
            console.log("VIDEO_SRC:: PREVIEW => CHANGEG");
            this.videoPreviewPlayer1.src = this.video_src;
          }
        }
        //this.videoPreviewPlayer1.src = this.video_src;
        //this.videoPreviewPlayer1.load();
      } else {
        if (1) {
          console.log(
            "VIDEO_SRC:: OLD, NEW, STATUS >2",
            this.videoPreviewPlayer1.src,
            this.brand_video_url
          );
          if (
            this.videoPreviewPlayer1.src &&
            this.videoPreviewPlayer1.src.indexOf(this.brand_video_url) !== -1
          ) {
            console.log("VIDEO_SRC:: STATUS > 2 NO CHANGE");
          } else {
            console.log("VIDEO_SRC:: STATUS > 2 CHANGED");
            this.brand_video_src_changed = true;
            this.videoPreviewPlayer1.src = this.brand_video_url;
          }
        }

        //this.videoPreviewPlayer1.load();
        //http://localhost:9000/api/brandVideo/getProducedVideo/1414?A…3%202021%2003:17:45%20GMT+0500%20(Pakistan%20Standard%20Time)
        console.log("PBV:: Branded video for preview not found");
      }
      if (this.brand_video_src_changed) {
        console.log("VIDEO_SRC:: SET TO FALSE, NEW SOURCE LOADED...");
        this.brand_video_src_changed = false;
        this.videoPreviewPlayer1.load();
      }
      if (this.status == 1 || this.status == 2 || this.status == 3) {
        //Step-1: Recording, Preview, Watermarking
        //this.brand_video_status_message = "Video getting ready to create, pick your call to action and music for your video";
        this.brand_video_status_message =
          "Video getting ready! In just a moment you can add your call to action and music for your video.";
        this.brand_video_progress = true;
        if (this.status == 3) {
          this.brand_video_progress = false;
          //this.brand_video_status_message = "Video ready, pick your call to action and music for your video";
          this.brand_video_status_message =
            "Video ready! Pick your call to action & music for your video.";
        }
      }
      if (this.status == 4) {
        this.brand_video_progress = true;
        //this.brand_video_status_message = "Creating video, it will take a moment, please wait...";
        this.brand_video_status_message =
          "Creating Video! In just a moment, you will have a professional video ready to download and share.";
        //accepted
        var completed_percentage = 0;
        /*
                this.elastic_transcoder values as given below
                Step-1: Creating Preview
                    1,11 => Watermarking
                    20,201 => Watermarking

                Step-2: Accepted
                    2,21
                    3,31
                    4,41
                    5,51
                    6,61
                    7,71,
                    8
                */
        if (this.elastic_transcoder == 0) {
        }
        //this.brand_video_status_message = "Creating Video" + completed + '%';
      }
      if (this.status == 100) {
        this.brand_video_progress = false;
        this.brand_video_status_message = "";
      }
      //this.brand_video_status_message = this.status + ' - ' + this.elastic_transcoder;
    }
  }

  generateTranscript() {
    this.loadingTranscript = true;

    this.api.generateTranscript(
      this.id,
      this.authService.getUser().token,
      () => {
        var transcript_url =
          this.transcript_src +
          this.id +
          "?Authorization=" +
          this.authService.getUser().token;
        if(this.transcript_src){
        this.transcriptGenerator.loadAWSJson(transcript_url, (json) => {
          if(json.length==0){
            this.userMessageService.setUserError("user","No Audio found for transcript")  
            this.subtitles.caption = [{
              sentence:"",
              start_time:"00:00.00",
              end_time:"00:00.00",
            }];

            } else {
              this.subtitles.caption = json;
            }
            this.loadingTranscript = false;
        });
      } 
      },
      () => {
        this.loadingTranscript = false;
      }
    );
  }

  getData() {
    var data = {
      id: this.id || null,
      account_owner_user_id: this.account_owner_user_id,
      customer_first_name: this.customer_first_name,
      customer_last_name: this.customer_last_name,
      customer_email: this.customer_email,
      video_name: this.update_video_name,
      video_topic: this.update_video_topic,
      call_to_action: this.call_to_action,
      background_music_id: this.background_music.id,
      instructions: this.instructions,
      include_email: this.include_email,
      include_phone: this.include_phone,
      include_call_to_action: this.include_call_to_action ? "Y" : "N",
      cta_override_website: this.cta_override_website,
      remove_cta: this.remove_cta,
      use_custom_opener: this.useCustomOpener,
      remove_start_opener_logo: this.removeStartOpenerLogo,
      font_id: this.call_to_action_font ? this.call_to_action_font.id : 0,
      subtitles: this.subtitles,
      use_subtitles: this.enableSubtitle,
      subtitle_style_index: this.transcriptGenerator.selectedIndex,
    };

    return data;
  }

  findBgMusic(id) {
    if (this.backgroundMusicList != "" && this.backgroundMusicList != null) {
      for (var i = 0; i < this.backgroundMusicList.length; i++) {
        if (this.backgroundMusicList[i].id == id)
          return this.backgroundMusicList[i];
      }

      var rand = Math.floor(Math.random() * this.backgroundMusicList.length);
      return this.backgroundMusicList[rand];
    }
  }

  bgMusicComparer(bg1, bg2) {
    if (bg1 && bg2) return bg1.id == bg2.id;

    return false;
  }

  findFont(id) {
    if (this.fontList != "" && this.fontList != null) {
      for (var i = 0; i < this.fontList.length; i++) {
        if (this.fontList[i].id == id) return this.fontList[i];
      }
    }
  }

  fontComparer(font1, font2) {
    if (font1 && font2) return font1.id == font2.id;

    return false;
  }

  send() {
    if (this.validate()) {
      this.sending = true;

      if (this.cta_files && this.cta_files.length > 0) {
        this.customCTAImageEnable = true;
        this.api.save(
          this.getData(),
          this.cta_files && this.cta_files.length > 0 && this.showCTAUpload
            ? this.cta_files[0]
            : null,
          this.authService.getUser().token,
          this.saveLoadSuccess.bind(this),
          this.saveLoadError.bind(this)
        );
      } else {
        this.api.sendRequest(
          this.getData(),
          this.authService.getUser().token,
          this.saveLoadSuccess.bind(this),
          this.saveLoadError.bind(this)
        );
      }
    }
  }


  videoNameLabelChange(videoNameChanged) {
    this.api.updateVideoName(
      this.id,
      videoNameChanged,
      this.authService.getUser().token,
      this.updateVideoNameSuccess.bind(this),
      this.saveLoadError.bind(this)
    );
  }
  updateVideoNameSuccess(data) {
    this.video_name = this.update_video_name;
  }


  videoTopicLabelChange(videoTopicChanged) {
    this.api.updateVideoTopic(
      this.id,
      videoTopicChanged,
      this.authService.getUser().token,
      this.updateVideoTopicSuccess.bind(this),
      this.saveLoadError.bind(this)
    );
  }
  updateVideoTopicSuccess(data) {
    this.video_topic = this.update_video_topic;
  }

  instructionsKeyUp() {
    var len = this.instructions.length;

    if (len > this.instructionsMax) {
      this.instructions = this.instructions.substring(0, this.instructionsMax);
    } else {
      this.instructionsCharsLeft = this.instructionsMax - len;
    }
  }

  instructionsChanged() {
    if (this.instructions_select != -1)
      this.instructions = this.instructions_select;
    else this.instructions = "";

    this.instructionsKeyUp();

    this.instructionsCtrl.focus();
  }

  callToActionKeyUp() {
    var len = this.call_to_action == null ? 0 : this.call_to_action.length;

    if (len > this.callToActionMax) {
      this.call_to_action = this.call_to_action.substring(
        0,
        this.callToActionMax
      );
    } else {
      this.callToActionCharsLeft = this.callToActionMax - len;
    }
  }

  callToActionChanged() {
    if (this.call_to_action_select != -1)
      this.call_to_action = this.call_to_action_select;

    this.callToActionKeyUp();
    this.callToActionCtrl.focus();
  }

  validate() {
    var pass = true;
    if (!this.brand_video) {
      if (
        this.customer_first_name == null ||
        this.customer_first_name.trim() == ""
      ) {
        this.userMessageService.setUserError(
          "user",
          "Customer First Name is empty"
        );
        pass = false;
      }
      if (this.customer_email == null || this.customer_email.trim() == "") {
        this.userMessageService.setUserError("user", "Customer Email is empty");

        pass = false;
      }

      if (!this.is_email(this.customer_email)) {
        this.userMessageService.setUserError(
          "user",
          "Customer Email is not a valid email address"
        );
        pass = false;
      }
    }

    if (this.brand_video) {
      if (
        this.update_video_name == null ||
        this.update_video_name.trim() == ""
      ) {
        this.userMessageService.setUserError("user", "Video Name is empty");
        pass = false;
      }
    }

    console.log("Validate Start");
    console.log(this.include_call_to_action);
    //console.log(thid.id);
    console.log(this.customCTALink);
    console.log("Validate End");

    if (
      this.id &&
      this.include_call_to_action &&
      this.customCTALink == null &&
      (this.call_to_action == null || this.call_to_action.trim() == "")
    ) {
      //if (this.include_call_to_action && this.customCTALink == null && (this.call_to_action == null || this.call_to_action.trim() == '')) {
      this.userMessageService.setUserError("user", "Call To Action is empty");
      pass = false;
    }

    //pass = false;

    return pass;
  }

  is_email(email) {
    var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailReg.test(email);
  }

  accept(processingWait = false) {
    if (processingWait && this.brand_video) {
      //this.saving = true;
      console.log("PW::: creating accepted brand video");
      this.api.getById(
        this.id,
        this.authService.getUser().token,
        (data) => {
          this.setData(data);
          console.log("PW::: data.status " + data.status);
          if (data.status == 4) {
            console.log(
              "PW::: calling load again " +
                data.status +
                " - " +
                data.elastic_transcoder
            );
            setTimeout(this.accept.bind(this), 5000, true);
          }
          if (data.status == 4 && data.elastic_transcoder == 71) {
            //video ready for preview
            console.log(
              "Video completed setting the progress bar balue to 100%"
            );
            $("#progressbar").progressbar("value", 50); //val = 99;
          }
          if (data.status == 100 && data.elastic_transcoder == 8) {
            console.log("BV Done::", data.status, data.elastic_transcoder);
            $("#progressbar").progressbar("value", 100); //val = 99;
            //location.reload();
          }
        },
        this.saveLoadError.bind(this)
      );
      if (this.run_once_accept) {
        console.log("Run Once:::");
        $("#progressbar").progressbar("value", 0);
        setTimeout(this.progress.bind(this), 12000);
        this.run_once_accept = false;
      }
    } else {
      console.log(this.getData());
      console.log(this.transcriptGenerator.selectedIndex)
      if (confirm("Are you sure you want to accept this video?")) {
        if (this.validate()) {
          if (this.enableSubtitle) {
            if (this.subtitles.caption.length == 0) {
              this.userMessageService.setUserError(
                "user",
                "Subtitles are empty."
              );
              return;
            }

            if(this.transcriptGenerator.selectedIndex!=null){
              this.subtitles.styles = this.transcriptGenerator.selectedStyle;
            }else{
              this.transcriptGenerator.selectedIndex=0;
              this.subtitles.styles= this.transcriptGenerator.styles[0]; //settting default styles

            }
            
          }

          console.log(this.transcriptGenerator.selectedIndex)
          console.log(this.getData())
// alert('5')
          // return 
          this.saving = true;
          this.api.acceptTestimonial(
            this.getData(),
            this.cta_files && this.cta_files.length > 0 && this.showCTAUpload
              ? this.cta_files[0]
              : null,
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this)
          );
        }

        if (this.run_once) {
          console.log("Run Once:::");
          $("#progressbar").progressbar("value", 0);
          //$("#progressbar").progressbar( "enable" );
          /*$("#progressbar").progressbar({
                        value: 2,
                        change: function() {
                            $(".progress-label").text( $("#progressbar").progressbar( "value" ) + "%" );
                        },
                        complete: function() {
                            $( ".progress-label" ).text( "Complete!" );
                        }
                    });*/
          setTimeout(this.progress.bind(this), 18000);
          this.run_once = false;
        }
      }
    }
  }

  delete() {
    if (confirm("Are you sure you want to delete this video?")) {
      this.saving = false;
      this.api.deleteTestimonial(
        this.getData(),
        this.authService.getUser().token,
        this.saveLoadSuccessDelete.bind(this),
        this.saveLoadError.bind(this)
      );
      console.log("window.site_url", window.site_url);
      // window.open(this.magnfiLink + "?short=true", "_blank");
    }
  }

  download() {
    if (this.brand_video && this.elastic_transcoder > 0) {
      ///brandVideo/getProducedVideo
      window.open(
        this.apiBase +
          "/brandVideo/getProducedVideo/" +
          this.id +
          "?Authorization=" +
          this.authService.getUser().token +
          "&t=" +
          new Date(),
        "_blank"
      );
    } else {
      window.open(this.videoPreviewPlayer.src, "_blank");
    }
  }

  downloadSubmittedvideo() {
    window.open(
      this.submitted_src +
        this.id +
        "?Authorization=" +
        this.authService.getUser().token +
        "&t=" +
        new Date(),
      "_blank"
    );
  }

  showVideoClicked() {
    this.showVideo = true;
    //setTimeout(function () {
    //    this.videoPreviewPlayer.focus();

    //}.bind(this), 100);
    this.videoPreviewPlayer.play();
  }

  showVideoClosed() {
    this.showVideo = false;
    if (this.videoPreviewPlayer) {
      this.videoPreviewPlayer.pause();
    }
  }

  //Youtube API

  yotubeAPILoaded() {
    this.youtubeApi.getClientId(
      this.authService.getUser().token,
      this.youtubeConfigured.bind(this),
      this.saveLoadError.bind(this)
    );
  }

  youtubeConfigured() {
    //this.youtubeApi.checkAuth();
    this.youtubeApiReady();
  }

  youtubeApiReady() {
    this.youtubeReady = true;
  }

  youtubeAuthRequired() {
    console.log("sss");
    this.youtubeApi.loginToYoutube();
  }

  startYoutubeUpload() {
    this.showSocialMediaUploadDialog(this.doYoutubeUpload.bind(this));
  }

  doYoutubeUpload() {
    this.socialMediaUploading = true;
    this.youtubeApi.uploadToYoutube(
      this.id,
      this.link_submission ? 1 : this.brand_video ? 2 : 0,
      this.socialMediaTitle,
      this.socialMediaTags,
      this.socialMediaDescription,
      this.videoVisibitily,
      this.uploadDefault,
      this.authService.getUser().token,
      this.socialMediaUploadSuccess.bind(this),
      this.saveLoadError.bind(this)
    );
  }

  updateToken(accessToken) {
    this.socialMediaUploading = true;
    this.youtubeApi.updateToken(
      accessToken,
      this.authService.getUser().token,
      this.socialMediaUploadSuccess.bind(this),
      this.saveLoadError.bind(this)
    );
  }

  uploadToYoutube() {
    // if (this.youtubeApi.access_token)
    this.startYoutubeUpload();
    // else
    // this.youtubeApi.loginToYoutube(this.startYoutubeUpload.bind(this));
    // this.youtubeApi.loginToYoutube(this.updateToken.bind(this));
  }

  uploadToYoutube() {
    // if (this.youtubeApi.access_token)
    this.startYoutubeUpload();
    // else
    // this.youtubeApi.loginToYoutube(this.startYoutubeUpload.bind(this));
    // this.youtubeApi.loginToYoutube(this.updateToken.bind(this));
  }

  /*
    //Facebook API

    facebookApiLoaded() {
        this.facebookInitialized = true;
        this.facebookApi.getAppId(this.authService.getUser().token, this.getFacebookAppIdSuccess.bind(this), this.saveLoadError.bind(this));
    }

    getFacebookAppIdSuccess() {
        this.facebookApi.initFacebookAPI(this.facebookApiConfigured.bind(this));
    }

    facebookApiConfigured() {
        //this.facebookApi.checkLoginStatus();
        this.facebookApiReady();
    }

    facebookApiReady() {
        this.facebookReady = true;
    }

    startFacebookUpload() {
        this.showSocialMediaUploadDialog(this.doFacebookUpload.bind(this));
    }

    doFacebookUpload() {
        this.socialMediaUploading = true;
        this.facebookApi.uploadToFacebook(this.id, this.link_submission ? 1 : (this.brand_video ? 2 : 0), this.socialMediaTitle, this.socialMediaDescription, this.authService.getUser().token, this.socialMediaUploadSuccess.bind(this), this.saveLoadError.bind(this));

    }

    uploadToFacebook() {
        //if (this.facebookApi.access_token)
        //    this.startFacebookUpload();
        //else
            this.facebookApi.loginToFacebook(this.startFacebookUpload.bind(this));
    }

    */

  showSocialMediaUploadDialog(callback) {
    this.socialMediaTitle = "";
    this.socialMediaTags = "";
    this.socialMediaDescription = "";
    this.socialMediaUploadCallback = callback;
    this.showSocialMediaDialog = true;
    $("body").addClass("lock-position");
  }

  uploadToSocialMedia() {
    this.socialMediaUploadCallback();
    // this.socialMediaUploadCallback = null;
  }

  cancelUpload() {
    this.showSocialMediaDialog = false;
    this.socialMediaUploading = false;
    $("body").removeClass("lock-position");
  }

  socialMediaUploadSuccess() {
    this.socialMediaUploading = false;
    this.showSocialMediaDialog = false;
    this.userMessageService.setUserMessage("user", "Upload Complete");
    $("body").removeClass("lock-position");
  }

  isPublicChanged() {
    this.api.setPublic(
      this.id,
      this.public,
      this.authService.getUser().token,
      (value) => {
        if (!value) this.featured = false;
      },
      this.saveLoadError.bind(this)
    );
  }

  isFeaturedChanged() {
    this.api.setFeatured(
      this.id,
      this.featured,
      this.authService.getUser().token,
      (featured) => {
        this.featured = featured;
      },
      (error) => {
        this.featured = false;
        this.saveLoadError(error);
      }
    );
  }

  uploadCTA() {
    this.showCTAUpload = true;
    this.remove_cta = false;
  }

  removeCTA() {
    this.remove_cta = true;
    this.customCTALink = null;
    this.cta_files = null;
  }
  cancelCTA() {
    this.showCTAUpload = false;
    if (1) {
      //Cancel button should remove the CTA in branded video
      this.remove_cta = true;
      this.customCTALink = null;
      this.cta_files = null;
    }
  }
  customCTAChanged() {
    if (
      this.cta_files &&
      this.cta_files[0] &&
      typeof FileReader === "function"
    ) {
      var reader = new FileReader();

      reader.onload = (e) => {
        this.customCTALink = e.target.result;
      };

      reader.readAsDataURL(this.cta_files[0]);
    }
  }

  capture(flag = false) {
    if (this.validate()) {
      this.saving = true;
      this.api.save(
        this.getData(),
        this.authService.getUser().token,
        (data) => {
          this.setData(data);
          sessionStorage["magnfi_captureKey"] =
            this.authService.getAccount().link_id;
          this.router.navigate("#/capture/video/brand/" + this.id);
        },
        this.saveLoadError.bind(this)
      );
    }
  }

  uploadCaptureOverride() {
    if (this.captureOverride_files && this.captureOverride_files.length > 0) {
      this.saving = true;
      this.api.saveCaptureOverride(
        this.id,
        this.captureOverride_files[0],
        this.authService.getUser().token,
        () => {
          this.overrideCaptureChanged(true);
        },
        (msg) => {
          this.userMessageService.setUserError("user", msg);
        }
      );
    }
  }

  removeCaptureOverride() {
    this.saving = true;
    this.api.removeCaptureOverride(
      this.id,
      this.authService.getUser().token,
      () => {
        this.overrideCaptureChanged(false);
      },
      (msg) => {
        this.userMessageService.setUserError("user", msg);
      }
    );
  }

  overrideCaptureChanged(capture_override) {
    this.userMessageService.setUserMessage("user", "Saved!");
    this.saving = false;
    this.capture_override = capture_override;
  }

  deleteCaptionRow(index) {
    this.subtitles.caption.splice(index, 1);

    if (this.subtitles.caption.length == 0) {
      this.subtitles.caption = [
        {
          start_time: "00:00.00",
          end_time: "00:01.00",
          sentence: "",
        },
      ];
    }
  }
  addCaptionRow(index = -1) {
    var startTime = "00:00.00";
    var endTime = "00:00.00";

    if(index==-2){
     endTime = "00:01.00";
      this.subtitles.caption.unshift({
        start_time: startTime,
        end_time: endTime,
        sentence: "Add text Here",
      });
    }
    if (index == -1) {
      if (this.subtitles.caption.length > 0) {
        var startTime = this.subtitles.caption[0].start_time;
        this.subtitles.caption.unshift({
          start_time: endTime,
          end_time: startTime,
          sentence: "",
        });
      }
    }else if (this.subtitles.caption.length-1 ==index){

      var endTime = this.subtitles.caption[index].end_time;
      this.subtitles.caption.push({
        start_time: endTime,
        end_time: endTime,
        sentence: "",
      });

    }else{

      var endTime = this.subtitles.caption[index].end_time;
      var startTime = this.subtitles.caption[index+1].start_time;
      this.subtitles.caption.splice(index+1,0,{
        start_time: endTime,
        end_time: startTime,
        sentence: "",
      });
    }
  }
  fetchChatbotDetails() {
    console.log("✅ fetchChatbotDetails() called");
  
    const user = this.authService.getUser();
    console.log("🔑 User object: ", user);
  
    if (!user || !user.token) {
      console.error("❌ Token is missing!");
      return;
    }
  
    console.log("🚀 Calling ChatBotAPI.getChatbotDetail with token:",this.chatbot, user.token);
  
    // Check if chatbot object is properly instantiated
    if (!this.chatbot) {
      console.error("❌ ChatBotAPI instance is not available!");
      return;
    }
  
    // Ensure getChatbotDetail method exists and is callable
    if (typeof this.chatbot.getChatbotDetail === "function") {
      console.log("✅ Calling getChatbotDetail method...");
      this.chatbot.getChatbotDetail(
        user.token,
        (chatbotDetail) => {
          console.log("✅ Chatbot Details: ", chatbotDetail);
          this.chatbotDetails = chatbotDetail; // Store chatbot details for the view
        },
        (error) => {
          console.error("❌ Error fetching chatbot details: ", error);
        }
      );
    } else {
      console.error("❌ getChatbotDetail is not a function.");
    }
  }
  showVideoChatBotDetail(){
    this.insertChatbotVideo = true;
    console.log('video seelcted')
    let preprocessed_link = this.brand_video_url.replace('produced.mp4', 'preprocessed.mp4')
     preprocessed_link = preprocessed_link.replace('output', 'input')
    const account_id = this.account_owner_user_id
    console.log(this.brand_video_url.replace('produced.mp4', 'preprocessed.mp4'))
    console.log(this.account_owner_user_id)
    this.youtubeApi.uploadVideoChatbot(
      account_id,
      preprocessed_link,
      this.id,
      this.isUsedInChatbot==1?"delete":"insert",
      this.authService.getUser().token,
      this.saveUploadSuccess.bind(this),
      this.saveLoadError.bind(this)
    );
  }


  saveUploadSuccess() {
    this.insertChatbotVideo = false;

    this.userMessageService.setUserMessage("user", "Added to the chatbot");
    $('#exampleModal').modal('hide');
    this.load();
  }
  
  
}
